import type { ToastVariants } from '~/components/_tailwind/toast/types'
import { THREE_AND_A_HALF_SECONDS_IN_MS } from '#shared/constants/durations'

// Type definition for toast message
export interface ToastMessage {
  message: string
  variant: ToastVariants
  id?: string
}

export default function useToast() {
  const toasts = useToasts()

  /**
   * Removes a toast by its ID from the toasts array
   * @param id - The ID of the toast to remove
   */
  function removeToast(id: string) {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  /**
   * Adds a toast message to the toasts array and automatically removes it after the specified timeout
   * @param toast - The toast message to add
   * @param timeout - The timeout in milliseconds after which the toast will be removed (default: 3500ms)
   * @returns The ID of the created toast
   */
  function addToast(toast: ToastMessage, timeout = THREE_AND_A_HALF_SECONDS_IN_MS): string {
    const id = generateUuid()
    toasts.value.push({ ...toast, id })

    setTimeout(() => {
      removeToast(id)
    }, timeout)

    return id
  }

  return {
    toasts,
    addToast,
    removeToast,
  }
}
